jQuery(function ($) {
    const $filterContainer = $('.ecom-wc-filter-container');

    if (!$filterContainer.length) return;

    const $filterPlaceholder = $filterContainer.find('.ecom-wc-filter-placeholder');
    const $filterForm = $filterContainer.find('.ecom-wc-filter');
    const $clearAllButton = $('.ecom-wc-filter__clear-all');
    const $filterItems = $filterForm.find('.ecom-wc-filter-item');
    const $checkboxes = $filterItems.find('.ecom-wc-filter-item__checkbox');
    const $itemToggles = $filterItems.find('.ecom-wc-filter-item-title');
    const $itemSearchFields = $filterItems.find('.ecom-wc-filter-item__search');
    const $selectedFiltersContainer = $('.ecom-wc-filter__selected-items');
    const $productsContainer = $('.products-holder');

    const $categoriesItems = $filterItems.find('.ecom-wc-filter-item__categories-item');
    const $categoryToggles = $filterItems.find('.ecom-wc-filter-item__categories-item-toggle');

    const filterItemOpenClass = 'ecom-wc-filter__item--open';
    const filterCategoryOpenClass = 'ecom-wc-filter-item__categories-item-toggle--open';
    const noTransitionsClass = 'ecom-wc-filter--no-transitions';

    let isMediaQueryChangeBound = false;
    let isAjaxLoading = false;
    let initialFilterState = null;
    let hasSubmitted = false;
    let currentRequest = null;

    const clearFilter = () => {
        $('.filter-group-item').remove();
        $('.ecom-wc-filter__selected-items ').hide();
        $checkboxes.prop('checked', false);

        if (Foundation.MediaQuery.atLeast('medium')) {
            submitForm();
        }

    }

    const showClearAll = () => {
        $clearAllButton.prop('disabled', false);
    }

    const hideClearAll = () => {
        $clearAllButton.prop('disabled', true);
    }

    const openItem = ($item) => {
        $item.addClass(filterItemOpenClass);

        focusSearchField($item);
    }

    const closeItem = ($item) => {
        $item.removeClass(filterItemOpenClass);
    }

    const focusSearchField = ($item) => {
        const $searchField = $item.find('.ecom-wc-filter-item__search');
        if ($searchField.length) {
            $searchField.focus();
        }
    }

    const toggleItem = ($item) => {
        if ($item.hasClass(filterItemOpenClass)) {
            closeItem($item);
        } else {
            openItem($item);
        }
    };


    $filterItems.find('.ecom-wc-filter-item__close-button').on('click', function () {
        const $item = $(this).closest('.ecom-wc-filter-item');
        closeItem($item);
    });

    $clearAllButton.on('click', clearFilter);

    $itemToggles.on('click', function () {
        const $parent = $(this).closest('.ecom-wc-filter-item');

        toggleItem($parent);
    });

    $itemSearchFields.on('keyup', function () {
        const $parent = $(this).closest('.ecom-wc-filter-item');
        const $searchTerm = $(this).val().toLowerCase();
        const $items = $parent.find('.ecom-wc-filter-item__label-wrapper');

        $items.each(function () {
            const $itemText = $(this).find('.ecom-wc-filter-item__label-text').text().toLowerCase();
            if ($itemText.includes($searchTerm)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    const openCategory = ($parent) => {
        $parent.addClass(filterCategoryOpenClass);
    }

    const closeCategory = ($parent) => {
        $parent.removeClass(filterCategoryOpenClass);
    }

    const toggleCategory = ($parent) => {
        if ($parent.hasClass(filterCategoryOpenClass)) {
            closeCategory($parent);
        } else {
            openCategory($parent);
        }
    }

    const submitForm = () => {
        if (isAjaxLoading) {
            // Cancel previous request if it's still running
            if (currentRequest) {
                currentRequest.abort();
            }
        }

        const price = document.querySelector('#minPrice')

        if (price.getAttribute('ignore')) {
            $('#minPrice').prop('disabled', true);
            $('#maxPrice').prop('disabled', true);
        }

        $filterForm.find('[name="s"]').remove();
        const formData = $filterForm.serialize();
        const currentUrl = window.location.href.split('?')[0];
        const targetUrl = `${currentUrl}?${formData}`;

        isAjaxLoading = true;
        $productsContainer.addClass('loading');

        // Update URL without page reload
        window.history.pushState({}, '', targetUrl);

        currentRequest = $.ajax({
            url: targetUrl,
            method: 'GET',
            success: function (response) {
                const $response = $(response);
                const $newProductsHolder = $response.find('.products-holder');
                const $products = $newProductsHolder.find('.products');

                const $noProducts = $newProductsHolder.find('.woocommerce-no-products-found');
                const $perPageAndSortingBlock = $newProductsHolder.find('.filter-block-items');
                const $paginationBlock = $newProductsHolder.find('.woocommerce-pagination');

                // Remove existing products or no-products message, keeping selected items
                $productsContainer.find('.products, .woocommerce-no-products-found,.filter-block-items,.woocommerce-pagination').remove();

                // Add new content
                $productsContainer.append($perPageAndSortingBlock);

                if ($products.length) {
                    $productsContainer.append($products);
                } else if ($noProducts.length) {
                    $productsContainer.append($noProducts);
                }

                if ($paginationBlock.length) {
                    $productsContainer.append($paginationBlock);
                }
            },
            error: function (jqXHR) {
                // Only do fallback if it's not an aborted request
                if (jqXHR.statusText !== 'abort') {
                    // Fallback to regular form submission on error
                    $filterForm[0].submit();
                }
            },
            complete: function () {
                isAjaxLoading = false;
                $productsContainer.removeClass('loading');
                currentRequest = null;

                $('#minPrice').prop('disabled', false);
                $('#maxPrice').prop('disabled', false);
            }
        });
    }

    const disableTransitions = () => {
        $filterForm.addClass(noTransitionsClass);
    }

    const enableTransitions = () => {
        $filterForm.removeClass(noTransitionsClass);
    }

    const openActiveItems = () => {
        disableTransitions();

        $filterItems.each(function () {
            const $item = $(this);

            if ($item.find('.ecom-wc-filter-item__checkbox:checked, .ecom-wc-filter-item__categories-item--current').length) {
                openItem($item);
            }
        });

        $categoriesItems
            .filter('.ecom-wc-filter-item__categories-item--current-parent, .ecom-wc-filter-item__categories-item--current')
            .each(function () {
                openCategory($(this));
            });

        adjustClearAllVisibility();

        setTimeout(() => {
            enableTransitions();
        }, 1000);
    }

    const adjustClearAllVisibility = () => {
        if ($checkboxes.is(':checked')) {
            showClearAll();
        } else {
            // hideClearAll();
        }
    };

    function removeFilterGroupItem($filterGroupItem, $checkbox) {
        $filterGroupItem.fadeOut(200, function () {
            const $group = $(this).closest('.filter-group-item');
            $(this).remove();

            if ($group.find('.filter-group-variation').length === 0) {
                $group.remove();
            }
            if ($('.filter-group-item').length === 0) {
                $selectedFiltersContainer.remove();
            }
        });
    }

    const updateSelectedFilters = ($checkbox) => {
        const $filterItem = $checkbox.closest('.ecom-wc-filter-item');
        const filterType = $checkbox.attr('name').replace('[]', '');
        const filterValue = $checkbox.val();
        const filterLabel = $filterItem.find('.ecom-wc-filter-item-title__content').text().trim();
        const itemLabel = $checkbox.closest('.ecom-wc-filter-item__label-wrapper').find('.ecom-wc-filter-item__label-text').text().trim();

        // Get both desktop and mobile containers
        const $selectedFiltersContainers = $('.ecom-wc-filter__selected-items');

        $selectedFiltersContainers.each(function () {
            const $container = $(this);
            const $existingFilterGroup = $container.find(`.filter-group-item[data-filter-type="${filterType}"]`);
            const $existingItem = $container.find(`.filter-group-variation[data-filter-type="${filterType}"][data-filter-value="${filterValue}"]`);

            if ($checkbox.prop('checked')) {
                $container.show();
                $container.find('.reset-filter').show();

                if (!$existingFilterGroup.length) {
                    const newGroup = `
						<div class="filter-group-item" data-filter-type="${filterType}">
							<p>${filterLabel}</p>
						</div>
					`;
                    $container.find('.filter-group').append(newGroup);
                }

                if (!$existingItem.length) {
                    const newItem = `
						<div class="filter-group-variation filter-group-variation-select"
							data-filter-type="${filterType}"
							data-filter-value="${filterValue}">
							<div>
								${itemLabel}
								<button type="button" class="remove-filter"
									title="Noņemt"
									aria-label="Noņemt">
									${window.crossFilterItem}
								</button>
							</div>
						</div>
					`;
                    $container.find(`.filter-group-item[data-filter-type="${filterType}"]`).append(newItem);
                }
            } else {
                $existingItem.fadeOut(200, function () {
                    $(this).remove();
                    const $group = $container.find(`.filter-group-item[data-filter-type="${filterType}"]`);
                    if (!$group.find('.filter-group-variation').length) {
                        $group.remove();
                    }
                    if (!$container.find('.filter-group-item').length) {
                        $container.hide();
                        $container.find('.reset-filter').hide();
                    }
                });
            }
        });
    };

    const saveFilterState = () => {
        const state = {};
        $checkboxes.each(function () {
            const $checkbox = $(this);
            state[$checkbox.attr('name') + '_' + $checkbox.val()] = $checkbox.prop('checked');
        });
        return state;
    };

    const restoreFilterState = (state) => {
        $checkboxes.each(function () {
            const $checkbox = $(this);
            const key = $checkbox.attr('name') + '_' + $checkbox.val();
            const wasChecked = state[key];

            if ($checkbox.prop('checked') !== wasChecked) {
                $checkbox.prop('checked', wasChecked);
                updateSelectedFilters($checkbox);
            }
        });
        adjustClearAllVisibility();
    };

    $checkboxes.on('change', function () {
        adjustClearAllVisibility();
        updateSelectedFilters($(this));

        if (Foundation.MediaQuery.atLeast('medium')) {
            submitForm();
        }
    });

    $categoryToggles.on('click', function (e) {
        e.preventDefault();

        const $parent = $(this).closest('.ecom-wc-filter-item__categories-item--has-children');

        toggleCategory($parent);
    });

    $filterForm.on('submit', function (e) {
        e.preventDefault();

        if (!Foundation.MediaQuery.atLeast('medium')) {
            const $reveal = $(this).closest('.reveal');
            if ($reveal.length) {
                hasSubmitted = true;
                $reveal.foundation('close');
            }
        }

        submitForm();
    });

    // Handle individual filter removal - delegate to document
    $(document).on('click', '.ecom-wc-filter__selected-items .remove-filter', function (e) {
        e.preventDefault();
        const $filterGroupItem = $(this).closest('.filter-group-variation');
        const filterType = String($filterGroupItem.data('filter-type'));
        const filterValue = String($filterGroupItem.data('filter-value'));

        const $checkbox = $checkboxes.filter(function () {
            let $this = $(this);

            const name = String($this.attr('name')).replace('[]', '');
            const value = String($this.val());

            return name === filterType && value === filterValue;
        }).first();

        if ($checkbox.length) {
            $checkbox.prop('checked', false);
            updateSelectedFilters($checkbox);
            adjustClearAllVisibility();

            if (Foundation.MediaQuery.atLeast('medium')) {
                submitForm();
            }
        }
    });

    // Handle reset all filters - delegate to document
    $(document).on('click', '.ecom-wc-filter__selected-items .reset-filter', function (e) {
        e.preventDefault();

        const $selectedFiltersContainer = $('.ecom-wc-filter__selected-items');

        $checkboxes.prop('checked', false);

        $selectedFiltersContainer.hide().find('.reset-filter').hide();
        $selectedFiltersContainer.find('.filter-group').empty();

        adjustClearAllVisibility();

        if (Foundation.MediaQuery.atLeast('medium')) {
            submitForm();
        }
    });

    function openMobileFilter() {
        const revealId = 'ecom-wc-filter-reveal';
        const $reveal = $('<div>', { class: 'reveal', id: revealId, 'data-reveal': true }).append($filterForm);

        $filterContainer.append($reveal);

        // Save initial state when opening
        initialFilterState = saveFilterState();
        hasSubmitted = false;

        new Foundation.Reveal($(`#${revealId}`)).open();

        $(document).one('closed.zf.reveal', `#${revealId}`, function closeHandler() {
            $filterPlaceholder.append($filterForm);
            $reveal.remove();

            // Restore state if closed without submitting
            if (!hasSubmitted && initialFilterState) {
                restoreFilterState(initialFilterState);
            }

            // Reset tracking variables
            initialFilterState = null;
            hasSubmitted = false;
        });

        if (!isMediaQueryChangeBound) {
            isMediaQueryChangeBound = true;

            $(window).on('changed.zf.mediaquery', function () {
                const $activeReveal = $(`#${revealId}`);

                if ($activeReveal.length) {
                    $activeReveal.foundation('close');
                }
            });
        }
    }

    $(document.body).on('click', '.ecom-wc-filter__mobile-toggle', function () {
        openMobileFilter();

    });

    // Handle orderby change with event delegation
    $(document).on('change', '.woocommerce-ordering select.orderby', function () {
        $(this).closest('form').submit();
    });

    openActiveItems();


    const rangeSlider = document.querySelector(".range-slider");
    if (rangeSlider) {
        const minPriceInput = document.getElementById("minPrice");
        const maxPriceInput = document.getElementById("maxPrice");
        const rangeMin = document.getElementById("rangeMin");
        const rangeMax = document.getElementById("rangeMax");
        const clearAll = document.querySelectorAll('.ecom-wc-filter__clear-all')


        let debounceTimer;

        function showSelected() {
            const selected = document.querySelector('.ecom-wc-filter__selected-items')
            const items = document.querySelectorAll('.filter-group-item')

            if (items.length) {
                selected.style.display = 'flex'
            } else {
                selected.style.display = 'none'
            }

        }

        function updateSelectedPrice(min, max) {
            const priceItem = document.querySelector('.filter-group-item[data-filter-type="price"]');
            const itemLabel = document.querySelector('.ecom-wc-filter-item-price .ecom-wc-filter-item-title').textContent
            const items = document.querySelector('.ecom-wc-filter__selected-items .filter-group')

            const htmlFilter = `
<div class="filter-group-item" data-filter-type="price">
    ${itemLabel}
    <div class="filter-group-variation filter-group-variation-select">
        <div>
            ${min} - ${max}€
            <button type="button" class="remove-filter remove-filter-price"
                title="Noņemt"
                aria-label="Noņemt">
                	<svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 4.5l-5 5m0-5l5 5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
        </div>
    </div>
</div>
`;

            if (priceItem) {
                priceItem.remove()
            }

            items.insertAdjacentHTML('beforeend', htmlFilter);
            showSelected()
            removeSelectedPrice()
        }

        function removeSelectedPrice() {
            const removeBtn = document.querySelector('.remove-filter-price');
            removeBtn && removeBtn.addEventListener('click', () => {
                getRemoveSelectedPrice()
            })
        }

        removeSelectedPrice()

        function getRemoveSelectedPrice() {
            console.log('wefwe');
            
            const priceItem = document.querySelector('.filter-group-item[data-filter-type="price"]');

            const minPrice = minPriceInput.getAttribute('min')
            const maxPrice = minPriceInput.getAttribute('max')
            const url = new URL(window.location);
            url.searchParams.delete('min_price');
            url.searchParams.delete('max_price');

            window.history.pushState({}, '', url);

            minPriceInput.value = minPrice;
            maxPriceInput.value = maxPrice;

            rangeMin.value = minPrice;
            rangeMax.value = maxPrice;
            updateSlider(null, false, true);

            minPriceInput.setAttribute('ignore', 'true');
            maxPriceInput.setAttribute('ignore', 'true');

            priceItem.remove()

            showSelected()
            submitForm()
        }


        clearAll.length && clearAll.forEach(clear => {
            clear.addEventListener('click', () => {
                getRemoveSelectedPrice()
                console.log('qwe');
                
            })
        })

        function debounce(func, delay) {
            return function (...args) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => func.apply(this, args), delay);
            };
        }

        function updateSlider(event, init = false, reset = false) {
            if (!reset) {
                minPriceInput.removeAttribute('ignore')
                maxPriceInput.removeAttribute('ignore')
            }
            let minVal = parseInt(rangeMin.value);
            let maxVal = parseInt(rangeMax.value);

            if (maxVal - minVal < 5) {
                if ( event && event.target === rangeMin) {
                    rangeMin.value = maxVal - 5;
                } else {
                    rangeMax.value = minVal + 5;
                }
            }

            minPriceInput.value = rangeMin.value;
            maxPriceInput.value = rangeMax.value;
            let percentMin = (rangeMin.value / rangeMin.max) * 100;
            let percentMax = (rangeMax.value / rangeMax.max) * 100;

            rangeSlider.style.left = percentMin + "%";
            rangeSlider.style.width = (percentMax - percentMin) + "%";

            if (!init && !reset) {
                updateSelectedPrice(rangeMin.value, rangeMax.value)
            }

            if (!init) {
                debounceAjax();

            }
        }

        function updateInputs() {
            let minVal = parseInt(minPriceInput.value);
            let maxVal = parseInt(maxPriceInput.value);

            if (minVal < 0) minPriceInput.value = 0;
            if (maxVal > 100) maxPriceInput.value = 100;
            if (maxVal - minVal < 5) {
                minPriceInput.value = maxVal - 5;
            }

            rangeMin.value = minPriceInput.value;
            rangeMax.value = maxPriceInput.value;

            updateSlider();
        }

        const debounceAjax = debounce(() => submitForm(), 300);

        rangeMin.addEventListener("input", updateSlider);
        rangeMax.addEventListener("input", updateSlider);
        minPriceInput.addEventListener("input", updateInputs);
        maxPriceInput.addEventListener("input", updateInputs);

        updateSlider(null, true);
    }



    const brands = document.querySelector('.ecom-wc-filter-brands')

    if (brands) {
        const items = brands.querySelectorAll('.ecom-wc-filter-item__label-wrapper')
        items.length && items.forEach(item => {
            item.addEventListener('click', () => {
                items.forEach(inner => {
                    inner.classList.remove('active')
                })

                item.classList.add('active')
            })
        })
    }
});
